import { DOWNLOAD_TYPE } from './insightsTypes';

export function isDownloadType(
  label: string | number | Boolean,
): label is DOWNLOAD_TYPE {
  return Object.keys(DOWNLOAD_TYPE).includes(`${label}`);
}
